import { render, staticRenderFns } from "./ChainSidebar.vue?vue&type=template&id=7a9dc28c"
import script from "./ChainSidebar.vue?vue&type=script&lang=ts"
export * from "./ChainSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports